// Fallback Nativity city list, used when the system configuration
// cannot be loaded. The live list is managed in Admin -> System Configuration
// and served via /api/system-config/public (nativity_options).
export const DEFAULT_NATIVITY_OPTIONS = [
  'Coimbatore',
  'Erode',
  'Tirupur',
  'Nilgiris',
  'Namakkal',
  'Salem'
];

// Applications store the region as a lowercase slug (e.g. "coimbatore"),
// while the configured list holds display names (e.g. "Coimbatore").
export const toNativityValue = (city: string): string => city.trim().toLowerCase();
